// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3EixK","footer":"ModalError_footer__3sMX6"};